import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useTranslation } from 'react-i18next';
import logoBlack from '../../assets/logo-black.png';

export default function AboutDialog({ open, onClose }) {
  const { t } = useTranslation();
  const fullScreen = useMediaQuery('(max-width: 599.95px), (max-height: 499.95px)');
  const items = ['locationSearch', 'realtimeLoad', 'waitTime', 'communityReports'];

  return (
    <Dialog open={open} onClose={onClose} fullScreen={fullScreen} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pr: 7 }}>
        {t('about.title')}
        <IconButton onClick={onClose} aria-label={t('place.close')} sx={{ position: 'absolute', insetInlineEnd: 12, top: 10 }}>
          <CloseRoundedIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2.5} sx={{ alignItems: 'center', py: { xs: 1, sm: 2 } }}>
          <Stack component="img" src={logoBlack} alt="Calmpi" sx={{ width: 155, maxWidth: '55%', height: 'auto' }} />
          <Typography color="text.secondary" textAlign="center" fontWeight={700}>
            {t('about.subtitle')}
          </Typography>
          <Typography sx={{ lineHeight: 1.8 }}>{t('about.description')}</Typography>
          <Stack spacing={1.1} sx={{ width: '100%' }}>
            {items.map((item) => (
              <Typography key={item} sx={{ p: 1.25, borderRadius: 2, bgcolor: 'action.hover' }}>
                {t(`about.items.${item}`)}
              </Typography>
            ))}
          </Stack>
          <Stack spacing={0.35} sx={{ pt: 1, alignItems: 'center' }}>
            <Typography variant="caption" color="text.secondary">Map rendering: MapLibre</Typography>
            <Typography variant="caption" color="text.secondary">Map tiles: CARTO</Typography>
            <Typography variant="caption" color="text.secondary">Map data: OpenStreetMap contributors</Typography>
            <Typography variant="caption" color="text.secondary">Place information: Google</Typography>
            <Typography variant="caption" color="text.secondary">© 2026 Calmpi</Typography>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}